import { PageShell } from '@/components/ui';

/**
 * QA-488 — 통계(임시). 2·3단계 메뉴와 화면은 외부 임시 통계 페이지가 관리하고, BO 는 메뉴 하나와 iframe 만 둔다.
 */
export const STATS_IFRAME_URL = 'https://everlineshop-temp-stats.web.app/c32dc4b8e86b032ebfd3ae4c/#sales-recent';

export const StatsPage = () => (
  <PageShell title="통계">
    <iframe
      src={STATS_IFRAME_URL}
      title="통계"
      className="block w-full rounded-lg"
      style={{ height: 'calc(100vh - 160px)', minHeight: 600, border: '1px solid var(--divider-strong)', background: 'var(--surface-0)' }}
      data-testid="stats-iframe"
    />
  </PageShell>
);
